import * as React from 'react';
import {
    createTimeStreamAsset,
    moveTimeStreamAsset,
    getSelectedProjectId,
    getAsset,
} from 'owa-timestream-store';
import { getSearchableAsset } from 'owa-timestream-asset-search';
import { useGetCanvasPanZoomBounds } from '../components/GetCanvasPanZoomBounds';
import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import getCoordinatesForNewAsset from './getCoordinatesForNewAsset';

export default function useAddSearchResultToCanvas(
    assetType: string,
    item: SearchResultItem
): (element: HTMLElement) => void {
    const getCanvasPanZoomBounds = useGetCanvasPanZoomBounds();

    const newAssetPayload = {
        item: item,
    };

    const addSearchResultToCanvas = React.useCallback(
        (element: HTMLElement) => {
            const searchableAsset = getSearchableAsset(assetType);
            const targetRect = element.getBoundingClientRect();

            const { bounds, pan, zoom } = getCanvasPanZoomBounds();
            const { x, y } = getCoordinatesForNewAsset(bounds, pan, zoom, targetRect);

            const projectId = getSelectedProjectId();
            if (item.existingAssetId) {
                const { bounds } = getAsset(projectId, item.existingAssetId);
                moveTimeStreamAsset(projectId, item.existingAssetId, x - bounds.x, y - bounds.y);
            } else {
                const newAsset = {
                    ...searchableAsset?.createDragAsset(newAssetPayload),
                    x,
                    y,
                };

                createTimeStreamAsset(projectId, newAsset, 'ActivityPane');
            }
        },
        [useGetCanvasPanZoomBounds, item.existingAssetId, assetType, newAssetPayload]
    );

    return addSearchResultToCanvas;
}
